import React from 'react';
import './LatestCheckIn.css';
import logComponent from '../../common/logComponent';
import LatestCheckIn from './LatestCheckIn';
import { CardLatestCheckInProvider } from '../../contexts/CardLatestCheckInContext';
 
export default function LatestCheckInCard({ moduleDescription }) {
  if (logComponent('LatestCheckInCard')) { console.debug('LatestCheckInCard rendered'); }


  return (
    <CardLatestCheckInProvider>
      <LatestCheckIn moduleDescription={moduleDescription} />
    </CardLatestCheckInProvider>
  );
}